"use strict";
exports.__esModule = true;
exports.HttpClient = void 0;
/**
 * Http class
 */
var HttpClient = /** @class */ (function () {
    function HttpClient() {
    }
    return HttpClient;
}());
exports.HttpClient = HttpClient;
